import {post} from '../utils/request'

export default {
    getAll: function (query) {
        return post("/admin/banner/list", query || {});
    },
    findById: function (id) {
        return post("/admin/banner/show", {id});
    },
    create: function (device) {
        return post("/admin/banner/create", device);
    },
    update: function (device) {
        return post("/admin/banner/update", device);
    },

    deleteById: function (id) {
        return post("/admin/banner/delete", {id});
    },
}
